(() => {
  'use strict';

  const READY = 'vc-nav-v3--ready';
  const HIDDEN = 'vc-nav-v3--hidden';
  const DRAWER_OPEN = 'vc-nav-v3--drawer-open';
  const PREVIEW_PARAMS = ['preview_theme_id', 'preview_key', 'pb', 'locale'];

  const buildRoute = (path) => {
    const current = new URL(window.location.href);
    const url = new URL(path, window.location.origin);

    PREVIEW_PARAMS.forEach((key) => {
      const value = current.searchParams.get(key);
      if (value && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    return `${url.pathname}${url.search}${url.hash}`;
  };

  const normalizeRoutes = (header) => {
    header.querySelectorAll('.vch10__brand, .vch10-drawer__brand').forEach((link) => {
      link.href = buildRoute('/');
    });

    header.querySelectorAll('.vch10__desktop-nav a, .vch10-drawer__nav a').forEach((link) => {
      const text = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

      if (text.includes('buscar')) {
        link.remove();
        return;
      }

      if (text.includes('mirasai')) {
        link.href = buildRoute('/#mirasai');
        return;
      }

      if (text.includes('sobre nosotros') || text.includes('preguntas frecuentes')) {
        link.href = buildRoute('/pages/preguntas-frecuentes');
        const strong = link.querySelector('strong');
        if (strong) strong.textContent = 'Preguntas frecuentes';
        else link.textContent = 'Preguntas frecuentes';
        return;
      }

      if (text.includes('contacto')) {
        link.href = buildRoute('/pages/contact');
      }
    });
  };

  const init = () => {
    const header = document.querySelector('[data-vch10-header]');
    if (!header) return;

    if (typeof window.__vcMirasaiNavV4Cleanup === 'function') {
      window.__vcMirasaiNavV4Cleanup();
    }

    header.classList.remove(
      'vc-smart-nav--hidden',
      'vc-smart-nav-v2--ready',
      'vc-smart-nav-v2--hidden',
      HIDDEN,
      DRAWER_OPEN,
      READY
    );

    document.querySelectorAll('[data-vc-smart-nav-v2-spacer], [data-vc-nav-v3-spacer]').forEach((node) => node.remove());

    normalizeRoutes(header);

    const surface = header.querySelector('.vch10__surface');
    const menuButton = header.querySelector('[data-vch10-menu-button]');
    const cartButton = header.querySelector('[data-vch10-cart-button]');

    if (!surface) return;

    const controller = new AbortController();
    const { signal } = controller;

    let resizeObserver = null;
    let mutationObserver = null;
    let raf = 0;
    let lastY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    let upTravel = 0;
    let downTravel = 0;
    let lastTouchY = null;

    const spacer = document.createElement('div');
    spacer.setAttribute('data-vc-nav-v3-spacer', '');
    spacer.setAttribute('aria-hidden', 'true');
    header.parentElement?.insertBefore(spacer, header);

    const isDrawerOpen = () =>
      menuButton?.getAttribute('aria-expanded') === 'true' ||
      cartButton?.getAttribute('aria-expanded') === 'true';

    const syncDrawerState = () => {
      const open = isDrawerOpen();
      header.classList.toggle(DRAWER_OPEN, open);

      if (open) {
        header.classList.remove(HIDDEN, 'vc-smart-nav--hidden', 'vc-smart-nav-v2--hidden');
        upTravel = 0;
        downTravel = 0;
      }
    };

    const syncSpacer = () => {
      const height = Math.ceil(surface.getBoundingClientRect().height || surface.offsetHeight || 0);
      if (height > 0) spacer.style.height = `${height}px`;
    };

    const showHeader = () => {
      header.classList.remove(HIDDEN, 'vc-smart-nav--hidden', 'vc-smart-nav-v2--hidden');
      downTravel = 0;
    };

    const hideHeader = () => {
      if (isDrawerOpen()) {
        showHeader();
        return;
      }

      header.classList.add(HIDDEN);
      upTravel = 0;
    };

    syncSpacer();
    header.classList.add(READY);
    window.requestAnimationFrame(syncSpacer);
    syncDrawerState();

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncSpacer);
      resizeObserver.observe(surface);
    } else {
      window.addEventListener('resize', syncSpacer, { passive: true, signal });
    }

    mutationObserver = new MutationObserver(syncDrawerState);

    [menuButton, cartButton].forEach((button) => {
      if (button) {
        mutationObserver.observe(button, {
          attributes: true,
          attributeFilter: ['aria-expanded']
        });
      }
    });

    const onScrollFrame = () => {
      const currentY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      const delta = currentY - lastY;
      lastY = currentY;

      if (currentY <= 8 || isDrawerOpen()) {
        showHeader();
        upTravel = 0;
        downTravel = 0;
        raf = 0;
        return;
      }

      if (delta < 0) {
        upTravel += -delta;
        downTravel = 0;
        if (upTravel >= 2) showHeader();
      } else if (delta > 0) {
        downTravel += delta;
        upTravel = 0;
        if (downTravel >= 12) hideHeader();
      }

      raf = 0;
    };

    const onScroll = () => {
      if (!raf) raf = window.requestAnimationFrame(onScrollFrame);
    };

    const onWheel = (event) => {
      if (event.deltaY < -1) showHeader();
      else if (event.deltaY > 10 && !isDrawerOpen()) hideHeader();
    };

    const onTouchStart = (event) => {
      lastTouchY = event.touches?.[0]?.clientY ?? null;
    };

    const onTouchMove = (event) => {
      const y = event.touches?.[0]?.clientY;
      if (y == null || lastTouchY == null) return;

      const delta = y - lastTouchY;

      if (delta > 2) showHeader();
      else if (delta < -10 && !isDrawerOpen()) hideHeader();

      lastTouchY = y;
    };

    const onTouchEnd = () => {
      lastTouchY = null;
    };

    const onPageShow = () => {
      lastY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      showHeader();
      syncDrawerState();
      syncSpacer();
    };

    window.addEventListener('scroll', onScroll, { passive: true, signal });
    window.addEventListener('wheel', onWheel, { passive: true, signal });
    window.addEventListener('touchstart', onTouchStart, { passive: true, signal });
    window.addEventListener('touchmove', onTouchMove, { passive: true, signal });
    window.addEventListener('touchend', onTouchEnd, { passive: true, signal });
    window.addEventListener('pageshow', onPageShow, { passive: true, signal });

    window.__vcMirasaiNavV4Cleanup = () => {
      if (raf) window.cancelAnimationFrame(raf);
      controller.abort();
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      spacer.remove();
      header.classList.remove(READY, HIDDEN, DRAWER_OPEN);
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
